import * as React from 'react';
import type {IEventTemplate} from '../../../types/IEventTemplate';
import type {SequenceItem} from '../../../types/IEventTemplateMetadata';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {Timeline} from '@spaced-out/ui-design-system/lib/components/Timeline';
import {RoundTimelineItem} from './round-timeline-item';
import {BreakTimelineItem} from './break-timeline-item';
import {generateTestId} from '@spaced-out/ui-design-system/lib/utils/qa/qa';


interface SequenceDayItemProps {
  sequenceDay: SequenceItem;
  eventTemplate: IEventTemplate;
  testId?: string;
}

export const SequenceDayItem = ({
  sequenceDay,
  eventTemplate,
  testId,
}: SequenceDayItemProps) => {
  const {t} = useLabelTranslation();

  if (sequenceDay.type !== 'day') {
    return null;
  }

  const sequenceItems = sequenceDay.value || [];
  let roundNumber = 0;

  return (
    <Timeline
      orientation="left"
      testId={generateTestId({
        base: testId,
        slot: 'sequence-day-item-timeline',
      })}
    >
      {sequenceItems.map((sequenceItem, index) => {
        if (sequenceItem.type === 'round') {
          roundNumber += 1;
          const roundInfo = eventTemplate?.sequential_rounds?.find(
            (r) => r.id === sequenceItem.value.template_id,
          );

          return (
            <RoundTimelineItem
              key={`round-${roundNumber}-${index}`}
              roundNumber={roundNumber}
              roundInfo={roundInfo}
              index={index}
              testId={generateTestId({
                base: testId,
                slot: 'round-timeline-item',
                index: index.toString(),
              })}
            />
          );
        }

        if (sequenceItem.type === 'break') {
          const breakInfo = sequenceItem.value as Duration;
          return (
            <BreakTimelineItem
              key={`break-${index}`}
              breakInfo={breakInfo as {amount: number; unit: string}}
              index={index}
            />
          );
        }

        return null;
      })}
    </Timeline>
  );
};
